import { useQuery } from '@apollo/client';
import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

// Importa tu consulta GraphQL
import { GET_EQUIPMENT } from '../services/graphql/settings/settings-query';
import { driverStateAtom } from '../services/recoil/atoms/driverState';
import { EquipmentStateAtom } from '../services/recoil/atoms/SettingState';

export function useSettingData() {
  const setEquipment = useSetRecoilState(EquipmentStateAtom);
  const userInfo = useRecoilValue(driverStateAtom);

  const { data, refetch } = useQuery(GET_EQUIPMENT, {
    skip: userInfo?.role !== 'Driver',
  });

  useEffect(() => {
    if (data && data.getEquipment) {
      const equipment = data.getEquipment.data;
      setEquipment(equipment);
    }
  }, [data]);

  return { data, refetch };
}
